import {Subject} from 'rxjs';

/**
 * Estado do rodízio no celular, sem injeção: o item do carrinho (classe simples) e os cards leem daqui.
 * O servidor decide o preço da rodada; este estado só faz a tela mostrar o mesmo que ele vai cobrar.
 */
export class EstadoRodizioLoja {
  static ativo = false;
  static rodizio: any = null;
  static planos: any[] = [];
  static readonly mudou = new Subject<void>();

  private static categoriasAtivas = new Set<number>();
  private static categoriasDosPlanos = new Set<number>();

  static definaPlanos(planos: any[]) {
    EstadoRodizioLoja.planos = planos || [];
    EstadoRodizioLoja.categoriasDosPlanos = new Set<number>();
    for (const plano of EstadoRodizioLoja.planos)
      for (const categoria of (plano.categorias || []))
        EstadoRodizioLoja.categoriasDosPlanos.add(Number(categoria.id));
    EstadoRodizioLoja.mudou.next();
  }

  static definaRodizio(rodizio: any) {
    EstadoRodizioLoja.rodizio = rodizio || null;
    EstadoRodizioLoja.ativo = !!rodizio;
    EstadoRodizioLoja.categoriasAtivas = new Set<number>(
      ((rodizio && rodizio.categorias) || []).map((categoria: any) => Number(categoria.id)));
    EstadoRodizioLoja.mudou.next();
  }

  static categoriaDoProduto(produto: any): number {
    const categoria = produto && produto.categoria;
    return Number(categoria && typeof categoria === 'object' ? categoria.id : categoria) || null;
  }

  /** Produto que sai sem preço para quem entrou no rodízio (o adicional pago continua cobrado). */
  static produtoIncluido(produto: any): boolean {
    return EstadoRodizioLoja.ativo && !!produto && produto.tipo !== 'rodizio'
      && EstadoRodizioLoja.categoriasAtivas.has(EstadoRodizioLoja.categoriaDoProduto(produto));
  }

  /** Seção coberta pelo rodízio liberado neste celular. */
  static categoriaIncluida(categoria: any): boolean {
    return EstadoRodizioLoja.ativo && !!categoria && EstadoRodizioLoja.categoriasAtivas.has(Number(categoria.id));
  }

  /** Categoria de peças só do rodízio (coberta por um plano e sem nada com preço): escondida de quem não entrou. */
  static categoriaSoDoRodizio(categoria: any, produtos: any[]): boolean {
    if (EstadoRodizioLoja.ativo || !categoria || !EstadoRodizioLoja.categoriasDosPlanos.has(Number(categoria.id)))
      return false;

    return !(produtos || []).some((produto: any) => Number(produto.preco) > 0 || Number(produto.valorMinimo) > 0);
  }
}
